import {initSlotCarousel} from '../productTileComponent/productTile';

export default initSlotActivator;

function initSlotActivator() {
    const slotActivatorClass = '.js-plp-contentSlotActivator';

    if ($(slotActivatorClass).length > 0) {
        initSlotCarousel(slotActivatorClass);
    }
}
